import PortalIdParser from 'PortalIdParser';
export const getRootUrl = () => `/pricing/${PortalIdParser.get()}`;